import * as React from "react";
import { useHistory } from "react-router-dom";

import useWaitApiCall from "../../../hooks/useWaitApiCall";
import {
  Context,
  clearSuccessMessage,
  updateTeacherPassword,
  UPDATE_TEACHER_PASSWORD_SUCCESS_MESSAGE,
  loginPath,
  getUuidStatus,
} from "../../../teacherStore";
import TeacherResetPasswordForm from "../../../templates/teacher/TeacherResetPasswordForm";

export default (props: { match: { params: { uuid: string } } }) => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  const uuid = props.match.params.uuid;

  React.useEffect(() => {
    dispatch(peep(getUuidStatus(uuid)));
  }, [dispatch, uuid, peep]);

  React.useEffect(() => {
    if (state.success_message === UPDATE_TEACHER_PASSWORD_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(loginPath);
    }
  }, [history, dispatch, state.success_message]);

  const updateTeacherPasswordFunc = React.useCallback(
    (password: string) => {
      dispatch(updateTeacherPassword(uuid, password));
    },
    [dispatch, uuid],
  );

  return !calling ? (
    <TeacherResetPasswordForm
      updatePassword={updateTeacherPasswordFunc}
      isUuidExpired={state.isUuidExpired}
    />
  ) : null;
};
